<template>
    <div class="team-box">
        <div class="image-box">
            <img src="@/assets/image/ren.png" />
        </div>
        <div>
            <div class="content-right-box">
                <div>
                    <div class="img-box">
                        <img src="@/assets/image/jiaojuan.png" />
                    </div>
                    <div class="text-box">
                        <div class="text-top">
                            <span class="font-title">{{ planData.totalScore ? Number(planData.totalScore).toFixed(2) :
                                    '0'
                            }}</span>
                        </div>
                        <span class="font-status">
                            {{ $t('showLxRecordStudent.ZF') }}
                        </span>
                    </div>
                </div>
            </div>
            <p v-auth="[['teacher', 'student'], 'pro']" v-show="queryData.pattern_lx != 2">
                <el-tag size="mini">
                    {{ $t('showLxRecordStudent.SSBJ') }}
                </el-tag>
                <span class="team-name">{{ planData.playerDto.className ? planData.playerDto.className : '-' }}</span>
            </p>
            <p>
                <el-tag size="mini">
                    {{ $t('showLxRecordStudent.X') }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('showLxRecordStudent.M') }}
                </el-tag>
                <span class="leader-name nowrap">
                    {{ planData.playerDto.playerName }}
                </span>
            </p>
            <p>
                <el-tag size="mini">
                    {{ $t('showLxRecordStudent.LXSJ') }}
                </el-tag>
                <span class="status-text nowrap" v-if="planData.practiseLog">
                    {{ planData.practiseLog.startTime }} -- {{ planData.practiseLog.submitTime }}
                </span>
            </p>
        </div>

    </div>
</template>
<script>
export default {
    name: 'teamBox',
    props: {
        planData: Object
    },
    computed: {
        queryData() {
            return JSON.parse(this.__Base64.decode(this.$route.query.q))
        }
    }
}
</script>
<style lang="scss" scoped>
.team-box {
    display: flex;
}

.image-box {
    width: 150px;
    height: 166px;
    margin-right: 16px;

    img {
        width: 150px;
        height: 166px;
    }
}

p {
    margin: 12px 0;
    @include flex();
    align-items: center;

    .team-name {
        margin: 0 8px 0 0;
        font-size: 16px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        color: #0D141E;
        letter-spacing: 2px;
    }

    .icon-modify {
        color: #5397F7;
        font-size: 16px;
    }

    .icon-modify:hover {
        cursor: pointer;
        opacity: .8;
    }

    /deep/ .el-tag {
        margin-right: 16px;
    }

    .leader-name,
    .status-text {
        font-size: 14px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        color: #5D646E;
    }

    .red {
        color: #F77981;
    }
}

.content-right-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .img-box {
        width: 64px;
        height: 64px;
        opacity: 0.8;

        img {
            width: 100%;
        }
    }

    >div {
        display: flex;
        margin-right: 24px;
        flex: 1;
        margin-bottom: 0px;

        .text-box {
            margin: -8px 0 0 8px;

            .font-status,
            .font-title,
            .total-font {
                font-family: Hiragino Sans GB;
                font-weight: normal;
            }

            .font-title {
                font-size: 40px;
                color: #5397F7;
            }

            .total-font {
                font-size: 16px;
                margin-left: 5px;
                color: #5D646E;
            }

            .font-status {
                font-size: 14px;
                color: #5D646E;
                margin-left: 6px;
            }
        }
    }
}
</style>